exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".module-news {\n  display: inline-block;\n}\n.module-news .slider {\n  margin-left: 40px;\n  padding-bottom: 48px;\n  width: 570px;\n}\n.module-news .slider > div {\n  background: none;\n  border: none;\n  padding: 0;\n}\n", ""]);

